import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Clock, Star, Phone } from "lucide-react";
import logo from "@/assets/logo.png";

export const Footer = () => {
  return (
    <footer className="bg-[#000] text-gold">
      <div className="container-wide mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img src={logo} alt="Taekwondo Mattei" width={200} height={80} loading="lazy" decoding="async" className="h-20 w-auto" />
            <p className="font-body text-sm text-gold/70 leading-relaxed">
              Scuola di Taekwondo a Roma. Disciplina, crescita e rispetto per bambini, ragazzi e adulti.
            </p>
            <div className="flex gap-3 pt-2">
              <a
                href="https://www.instagram.com/taekwondomatteiroma/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gold/10 hover:bg-gold/20 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/taekwondomattei"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gold/10 hover:bg-gold/20 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://wa.me/393333346514"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gold/10 hover:bg-gold/20 transition-colors"
                aria-label="WhatsApp"
              >
                <Phone size={20} />
              </a>
              <a
                href="mailto:taekwondomatteiroma@gmail.com"
                className="p-2 rounded-full bg-gold/10 hover:bg-gold/20 transition-colors"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-display text-lg font-semibold text-gold">Link Rapidi</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/asd" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                A.S.D. Taekwondo Mattei Roma
              </Link>
              <Link to="/academy" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Academy
              </Link>
              <Link to="/percorsi" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Percorsi
              </Link>
              <Link to="/maestri" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Maestri
              </Link>
              <Link to="/vita-in-palestra" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Palestra
              </Link>
              <Link to="/blog" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Blog
              </Link>
              <Link to="/contatti" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Contatti
              </Link>
              <Link to="/lezione-di-prova" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Lezione di Prova
              </Link>
              <Link to="/stagione-2026-2027" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Iscrizioni 2026/2027
              </Link>
              <div className="pt-3 mt-1 border-t border-gold/10">
                <span className="font-body text-xs uppercase tracking-wider text-gold/80">Corsi</span>
              </div>
              <Link to="/corsi/bambini" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Bambini (4-13)
              </Link>
              <Link to="/corsi/ragazzi" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Ragazzi (14-17)
              </Link>
              <Link to="/corsi/adulti" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Adulti (18+)
              </Link>
              <Link to="/corsi/agonismo" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Agonismo
              </Link>
            </nav>
          </div>

          {/* Sede e Palestra */}
          <div className="space-y-4">
            <h4 className="font-display text-lg font-semibold text-gold">Sede e Palestra</h4>
            <div className="flex items-start gap-3 font-body text-sm text-gold/70">
              <MapPin size={16} className="mt-0.5 flex-shrink-0" />
              <span>Via Marino Mazzacurati, 90 – 00148 Roma (RM)</span>
            </div>
            <div className="pt-3 border-t border-gold/10 space-y-2">
              <div className="flex items-center gap-2 font-body text-sm font-medium text-gold">
                <Clock size={14} />
                <span>Orari</span>
              </div>
              <div className="space-y-1 font-body text-sm text-gold/70">
                <p>Lun / Mer / Ven: 17:30 - 20:00</p>
                <p>Mar / Gio / Sab / Dom: Chiuso</p>
              </div>
            </div>
            <div className="pt-3 border-t border-gold/10 space-y-2">
              <span className="font-body text-xs uppercase tracking-wider text-gold/80">Dove siamo</span>
              <nav className="flex flex-col gap-2 pt-1">
                <Link to="/dove-siamo/portuense" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                  Portuense
                </Link>
                <Link to="/dove-siamo/monteverde" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                  Monteverde
                </Link>
                <Link to="/dove-siamo/bravetta" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                  Bravetta
                </Link>
                <Link to="/dove-siamo/corviale" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                  Corviale
                </Link>
                <Link to="/dove-siamo/trullo" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                  Trullo
                </Link>
              </nav>
            </div>
          </div>

          {/* Taekwondo nella tua zona */}
          <div className="space-y-4">
            <h4 className="font-display text-lg font-semibold text-gold">Taekwondo nella tua zona</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/blog/taekwondo-portuense-roma" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Taekwondo Portuense
              </Link>
              <Link to="/blog/taekwondo-trullo-corviale-roma" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Taekwondo Trullo e Corviale
              </Link>
              <Link to="/blog/taekwondo-bravetta-casetta-mattei" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Taekwondo Bravetta e Casetta Mattei
              </Link>
              <Link to="/blog/taekwondo-monteverde-casaletto-roma" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Taekwondo Monteverde e Casaletto
              </Link>
              <Link to="/blog/accademia-arti-marziali-roma" className="font-body text-sm text-gold/70 hover:text-gold transition-colors">
                Arti marziali Roma
              </Link>
            </nav>
          </div>

          {/* Google Review Box */}
          <div className="space-y-4">
            <h4 className="font-display text-lg font-semibold text-gold">La tua opinione conta</h4>
            <p className="font-body text-sm text-gold/70 leading-relaxed">
              Hai provato i nostri corsi? Raccontaci la tua esperienza e aiuta altre famiglie a scoprirci!
            </p>
            <div className="flex gap-1 pt-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="fill-gold text-gold" />
              ))}
            </div>
            <a
              href="https://da.je/tkdmattei"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gold/10 hover:bg-gold/20 border border-gold/30 text-gold font-body text-sm font-medium px-5 py-2.5 rounded-lg transition-colors"
            >
              Lascia una recensione su Google
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-gold/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-body text-xs text-gold/80">
              © 2025 A.S.D. Taekwondo Mattei Roma · C.F. 97831630583 · Powered by{" "}
              <a href="https://protot.ai" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold/80 transition-colors underline">Protot.ai</a>
              {" "}(una società di{" "}
              <a href="https://iconi.co" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold/80 transition-colors underline">ICONI.CO</a>)
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="font-body text-xs text-gold/80 hover:text-gold transition-colors">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="font-body text-xs text-gold/80 hover:text-gold transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
